import api from "../Services/Api";
import {observable} from "mobx";

// значения совпадают с SkladEntityType на бэкенде
export const skladEntityTypes = [
    {key: 1, value: 1, text: 'Product'},
    {key: 2, value: 2, text: 'Variant'},
    {key: 3, value: 3, text: 'Bundle'},
];

class EventTesterStore {
    @observable stockTransferEventId: string = "";
    @observable skladEntityUserId: string = "";
    @observable skladEntityId: string = "";
    @observable skladEntityType: number = 1;
    @observable visible: boolean = false;
    @observable forDebug: boolean = false;

    setStockTransferEventId(value: string) {
        this.stockTransferEventId = value;
    }

    setSkladEntityUserId(value: string) {
        this.skladEntityUserId = value;
    }

    setSkladEntityId(value: string) {
        this.skladEntityId = value;
    }

    setSkladEntityType(value: number) {
        this.skladEntityType = value;
    }

    async triggerStockTransferEventHandler() {
        const result = await api.post('admin/stockTransferEventHandler.trigger', {
            id: this.stockTransferEventId,
            forDebug: this.forDebug
        });
        if (result.success) {
            this.setStockTransferEventId('')
        }
    }

    async triggerSkladEntityChangesProcessor() {
        const result = await api.post('admin/skladEntityChanges.trigger', {
            userId: this.skladEntityUserId,
            entityId: this.skladEntityId,
            entityType: this.skladEntityType,
            forDebug: this.forDebug
        });
        if (result.success) {
            this.setSkladEntityId('')
        }
    }

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
        this.stockTransferEventId = "";
        this.skladEntityUserId = "";
        this.skladEntityId = "";
        this.skladEntityType = 1;
        this.forDebug = false;
    }

    changeForDebug(value: boolean) {
        this.forDebug = value;
    }
}

export default new EventTesterStore();
